<template>

    <button v-if="showFavorite"
            class="favorites-button"
            :class="buttonClasses"
            aria-label="Manage Favorite"
            @click="manageFavorite">

        <span v-if="!favorite"
              class="fa-stack"
              :style="iconStackStyle">
          <i class="fas fa-heart fa-inverse fa-stack-1x" 
             role="presentation" 
             :style="{ fontSize: `${size - 2}px` }"/>
          <i class="far fa-heart fa-stack-1x" role="presentation"/>
        </span>

        <i v-else
           class="fa-heart"
           :style="iconSize"
           :class="favClass"
           role="presentation"/>

        <span v-if="addToFavoritesLabel && !favorite"
              :style="labelSize"
              class="favorites-button__label">
            {{ addToFavoritesLabel }}
        </span>

        <span v-else-if="removeFromFavoritesLabel && favorite"
              :style="labelSize"
              class="favorites-button__label">
            {{ removeFromFavoritesLabel }}
        </span>

    </button>

</template>

<script>
    import ApiFavorite from '@/api/Favorite'

    export default {
        name: 'favorite',
        props: {
            favorableId: {
                type: String,
                required: true
            },
            favorableType: {
                type: String,
                required: true
            },
            size: {
                type: Number,
                default: 32
            },
            addToFavoritesLabel: {
                type: String,
                default: null
            },
            removeFromFavoritesLabel: {
                type: String,
                default: null
            },
            withBorder: {
                type: Boolean,
                default: false
            },
            addToFavoritesFunction: {
                type: Function,
                default: null
            },
            removeFromFavoritesFunction: {
                type: Function,
                default: null
            }
        },
        computed: {
            showFavorite () {
                // Hide "Favorite" buttons until full functionality is implemented.
                return false
                // return this.signedIn
            },
            favorite () {
                return this.$store.getters['user/isFavorite'](this.favorableId)
            },
            signedIn () {
                return this.$store.getters['auth/signedIn']
            },
            favClass () {
                return this.favorite ? 'fas' : 'far'
            },
            iconSize () {
                return { fontSize: this.sizeInPixels }
            },
            labelSize () {
                return { fontSize: `${this.size * 0.55}px` }
            },
            buttonClasses () {
                return {
                    'favorites-button--active': this.favorite
                }
            },
            sizeInPixels () {
              return `${this.size}px`
            },
            iconStackStyle () {
                return {
                  width: this.sizeInPixels,
                  height: this.sizeInPixels,
                  fontSize: this.sizeInPixels,
                  marginTop: `-${this.size}px`
                }
            },
            computedAddToFavoritesFunction () {
                return this.invokeFunction(
                    this.addToFavoritesFunction,
                    this.defaultAddToFavoritesFunction
                )
            },
            computedRemoveFromFavoritesFunction () {
                return this.invokeFunction(
                    this.removeFromFavoritesFunction,
                    this.defaultRemoveFromFavoritesFunction
                )
            }
        },
        methods: {
            manageFavorite () {
                const fnName = this.favorite ? 'computedRemoveFromFavoritesFunction' : 'computedAddToFavoritesFunction'
                this[fnName]()
            },
            defaultAddToFavoritesFunction () {
                const payload = {
                    favorable_id: this.favorableId,
                    favorable_type: this.favorableType
                }

                ApiFavorite.addFavorite(this.$axios, payload)
                    .then(response => {
                        let payload = {}
                        payload[response.data.favorable_id] = response.data.id
                        this.$store.dispatch('user/addFavorite', payload)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            defaultRemoveFromFavoritesFunction () {
                ApiFavorite.removeFavorite(this.$axios, this.$store.getters['user/favoriteId'](this.favorableId))
                    .then(() => {
                        this.$store.dispatch('user/removeFavorite', this.favorableId)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            invokeFunction (fn, defaultFn) {
                return fn && typeof fn === 'function' ? fn : defaultFn
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/stylesheets/variables.scss';

    .favorites-button {
        display: flex;
        align-items: center;
        column-gap: 10px;
        background: none;
        outline: none;
        border: none;
        width: fit-content;
        cursor: pointer;
        color: $charleston-green;

        &--active {
            color: $add-cart-color;
        }
    }

</style>
